import { render, staticRenderFns } from "./AccountBlocked.vue?vue&type=template&id=2d9f2924&scoped=true&"
import script from "./AccountBlocked.vue?vue&type=script&lang=js&"
export * from "./AccountBlocked.vue?vue&type=script&lang=js&"
import style0 from "./AccountBlocked.vue?vue&type=style&index=0&id=2d9f2924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9f2924",
  null
  
)

export default component.exports